import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@app/app.component';
import { appConfig } from '@app/app.config';
import { environment } from '@environment';
import { WindowWithUser } from '@longnecktech/splash-commons-fe';
import { getTokenParams } from '@shared/utils/get-token-params';

const { token, instance, gameUuid, language: urlLang } = getTokenParams();

if (token) {
  const selectedLanguage = urlLang || decodeTokenLang(token) || 'en';

  fetch(`${environment.backendUrl}/api/public/auth/token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': selectedLanguage,
    },
    body: JSON.stringify({
      token,
      instance,
      gameUuid,
      language: selectedLanguage,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      (window as WindowWithUser).user = data;
      bootstrapApplication(AppComponent, appConfig).catch((err) => {
        console.error(err);
      });
    })
    .catch((error) => console.error('Authentication error:', error));
} else {
  console.warn('No token!');
}

function decodeTokenLang(token: string): string | null {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload?.language ?? null;
  } catch (err) {
    console.warn('Failed to decode JWT', err);
    return null;
  }
}
